import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Axios from './httpConfig/http';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueSimpleAlert from "vue-simple-alert";

Object.defineProperty(Vue.prototype, '$http', {
  get() {
    return Axios;
  }
});
Vue.$http = Axios;

Vue.use(VueSimpleAlert);
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
